module.exports = __webpack_public_path__ + "static/img/201.215591e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/csfish/201.png
// module id = zUDj
// module chunks = 0